export default __webpack_public_path__ + "static/media/modo.4779b8a5.png";